export const FETCH_PEOPLE = 'FETCH_PEOPLE'
export const FETCH_PEOPLE_REQUEST = 'FETCH_PEOPLE_REQUEST'
export const FETCH_PEOPLE_SUCCESS = 'FETCH_PEOPLE_SUCCESS'